<template>
  <b-form-select v-model="localCurrencyValue">
    <b-form-select-option v-for="currency in currencyOptions" :key="currency.code" :value="currency.code" :disabled="isDisabled">
      {{ currency.name }} (<span v-html="currency.symbol"></span>)
    </b-form-select-option>
  </b-form-select>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  name: 'CurrencyPicker',
  components: {},
  props: {
    value: {
      type: String,
      required: true
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany",
      currencyOptions: "main/getCurrencyOptions",
    }),
    localCurrencyValue: {
      get () { return this.value },
      set (localCurrencyValue) { this.$emit('input', localCurrencyValue) }
    },
    isDisabled () {
      let dis = true
      if (this.currentCompany.is_premium || this.$route.name === 'QuotationCreate') {
        dis = false
      }
      return dis
    }
  },
  created () {
    if (!this.currencyOptions || this.currencyOptions.length < 1) {
      this.loadCurrencyOptions()
    }
  },
  methods: {
    ...mapActions ({
      loadCurrencyOptions: "main/loadCurrencyOptions"
    })
  }
};
</script>
<style lang="scss">

</style>